import { Box, Flex, Text } from "@chakra-ui/layout";
import HealthyHeartIcon from "../areas-icons/HealthyHeartIcon";
import UnhealthyHeartIcon from "../areas-icons/UnhealthyHeartIcon";
import { ReadingValueBreakdown } from "@tether-web-portal/components/areas/location-reading/makeSampleBreakdown";

export const DeviceReadingModalItem = ({
  isHealthy,
  IconComponent,
  title,
  label,
  ignoreHealthReading = false,
}: ReadingValueBreakdown) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" pb={4}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        boxSize="50px"
        borderRadius="full"
        bg="gray.50"
      >
        <IconComponent size={28} />
      </Box>
      <Text pt="6px" color="gray.primary">
        {title}
      </Text>
      <Flex flexDirection="row" alignItems="center">
        {Boolean(!ignoreHealthReading) && <>{isHealthy ? <HealthyHeartIcon /> : <UnhealthyHeartIcon />}</>}
        <Text pl="4px" fontSize={18}>
          {label}
        </Text>
      </Flex>
    </Box>
  );
};
